module.exports = __webpack_public_path__ + "static/media/ayesha.75f29873.jpg";